﻿import { FIQAssist } from "../../app";
import { Inject, Injectable } from "@fiqas/angular-utils";
import { FiqassistApiServiceBase } from "./fiqassistApiServiceBase";
import { WebLink } from "../../models/base";
import { IIdentityLink, IIdentityResolver, CollectionResult } from "../../interfaces/iFqs"
import { Person, PersonData } from "../../models/person";
import { AuthenticationService } from "../authenticationService";
import { FqsService } from "../fqsService";
import { HomeService } from "./homeService";
import { ReportParameters, ReportCollection, BalanceReportParameters } from "../../models/recordReport";
import { CompactServiceCase } from "../../models/serviceCase";
import { AuthorizationService } from "../authorizationService";


@Injectable({
    module: FIQAssist,
    selector: ReportService.selector
})
export class ReportService extends FiqassistApiServiceBase {
    public static selector = "ReportService"

    private apiUrl;

    constructor(
        @Inject('$q') $q: angular.IQService,
        @Inject('$http') $http: angular.IHttpService,
        @Inject() authenticationService: AuthenticationService,
        @Inject() authorizationService: AuthorizationService
    ) {
        super($q, $http, authenticationService, authorizationService);
    }

    public async GetReport(url: string, parameters: ReportParameters | BalanceReportParameters) {
        return this.performRequest<void, ReportCollection>("GET", url, parameters);
    }

    public async GetReportCases(url: string) {
        return this.performRequest<void, CollectionResult<CompactServiceCase>>("GET", url);
    }
}
